import {SET_MARKER} from '../actions/marker';

const initialState = [];

export const marker = (state = initialState, action) => {
    switch(action.type)
    {
        case SET_MARKER : 
        return [...action.payload]
        default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/marker.js